{{#> elements/_dt }}
  {{> elements/_label }}
{{/elements/_dt}}
<dd>
  <dl>
    <dt>
      <label class="field-label" for="{{id}}_date">Date</label>
    </dt>
    <dd>
      <select name="{{prefix}}[{{name}}][date]" id="{{id}}_date">
        {{#each date_options}}
          <option value="{{this}}" {{#equal this ../value}}selected{{/equal}}>{{this}}</option>
        {{/each}}
      </select>
    </dd>
    <dt class='optional'>
      <label class="field-label" for="{{id}}_time">Time</label>
    </dt>
    <dd>
      <select name="{{prefix}}[{{name}}][time]" id="{{id}}_time">
        {{#each time_options}}
          <option value="{{this}}" {{#equal this ../value}}selected{{/equal}}>{{this}}</option>
        {{/each}}
      </select>
    </dd>
  </dl>
</dd>
